import React from 'react';
import MediaCount from "app/app/mediaSelector/atoms/MediaCount";
import useMediaDownload from "app/app/mediaSelector/hooks/use-media-download";
import {CSSTransition} from "react-transition-group";
import useMediaSelect from "app/app/mediaSelector/hooks/use-media-select";
import useMediaTranslation from "app/app/mediaSelector/hooks/use-translation";

function MediaSelectorBar(props) {
    const trans = useMediaTranslation();
    const {title} = props;
    const [downloadSelectedMedia, loading] = useMediaDownload();
    const {selectedMedia, resetSelectedMedia} = useMediaSelect();
    let shouldAnimate = selectedMedia.length > 0;

    return (
        <CSSTransition
            in={shouldAnimate}
            unmountOnExit
            timeout={300}
            classNames={'media-bar-'}
        >
            <div className={'media-bar '}>
                <div className={'media-bar__content page_container'}>

                    <div className={'container selected-media'}>
                        <MediaCount className={'heading'}/>
                        <button className={'reset-selected-btn'} onClick={() => resetSelectedMedia()}>x</button>
                        {trans.media_bar.chosen_files}
                    </div>

                    <span className={'seperator'}/>

                    <div className={'container media-format'}>
                        <span className={'heading'}>.zip</span>
                        {trans.media_bar.file_format}
                    </div>

                    <span className={'seperator'}/>

                    <div className={'container image-bundle'}>
                        <span className={'heading'}>{title}</span>
                        {trans.general.media_bundle}
                    </div>

                    <span className={'seperator'}/>

                    <div className={'container disclaimer'}>
                        {trans.media_bar.disclaimer}
                    </div>

                    <button type={'button'}
                            className={'button small red'}
                            onClick={() => downloadSelectedMedia()}
                            disabled={loading && true}
                    >
                        {trans.general.download}
                        {loading && <div className={'bar-loader'}>loading</div>}
                    </button>
                </div>
            </div>
        </CSSTransition>
    );
}

export default MediaSelectorBar;
